import { createFileRoute, Navigate } from "@tanstack/react-router";
import { requireRole } from "@/auth/requireRole.ts";
import { ROLE_ADMIN } from "@/constants";

export const Route = createFileRoute("/_dashboard/annuaire/")({
  beforeLoad: (args) => {
    requireRole([ROLE_ADMIN])(args);
  },
  component: RouteComponent,
});

function RouteComponent() {
  return <Navigate to={"/annuaire/$tab"} params={{ tab: "people" }} />;
}
